import { walletInstance } from '../utils/axiosConfig';

const WalletService = {
    // Créer un nouveau wallet
    createWallet: async (walletData) => {
        try {
            const response = await walletInstance.post('/create', walletData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in createWallet:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un wallet
    updateWallet: async (walletData) => {
        try {
            const response = await walletInstance.put('/update', walletData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in updateWallet:', error.message || error);
            throw error;
        }
    },

    // Supprimer un wallet
    deleteWallet: async (id) => {
        try {
            const response = await walletInstance.delete(`/delete/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in deleteWallet:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les wallets
    getAllWallets: async () => {
        try {
            const response = await walletInstance.get('/findAll');
            return response.data;
        } catch (error) {
            console.error('Error in getAllWallets:', error.message || error);
            throw error;
        }
    },

    // Récupérer un wallet par son ID
    getWalletById: async (id) => {
        try {
            const response = await walletInstance.get(`/find/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error in getWalletById:', error.message || error);
            throw error;
        }
    }
};

export default WalletService;